import { defineStore } from 'pinia'

export const usePhoneTypesStore = defineStore('phoneTypes', {
    state: () => {
        return {
            phoneTypes: [],
            appsCommon: [],
            /**
             * When a configuration is selected, it's chosenModel is selected and so is the phoneTypeIndex
             */
            phoneTypeIndex: -1,
        }
    },
    actions: {
        setPhoneTypes (phoneTypes) {
            this.phoneTypes = phoneTypes
        },
        getPhoneTypes () {
            return this.phoneTypes
        },
        setAppsCommon (appsCommon) {
            this.appsCommon = appsCommon
        },
        getAppsCommon () {
            return this.appsCommon
        },
    },
    getters: {}

})
